import { useState, useEffect } from "react"
import { BrowserRouter as Router } from "react-router-dom";
import AppRouter from "./AppRouter";
import { HelmetProvider } from "react-helmet-async";
import Loader from "./components/ui/Loader";
import { CartProvider } from "./context/CartContext";
import CartDrawer from "./components/CartDrawer"
//import CartButton from "./components/CartButton";


function App() {

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulamos la carga inicial de la plataforma
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2500);

    return () => clearTimeout(timer);
  }, []);

  return (
    <Router>
      <HelmetProvider>
        <Loader isLoading={loading} />
        <CartProvider>
          <AppRouter />
          <CartDrawer />
          {/*<CartButton />*/}
        </CartProvider>
      </HelmetProvider>
    </Router>
  );
}

export default App;